import { ethereum } from './paths';
export default [ethereum];
